import { useMemo } from 'react';
import { Box, Typography, Grid, Paper, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import type { Entry, SymptomReading } from '@lorrainemarwood-care/shared';
import { api } from '../lib/api';
import EntryForm from '../components/EntryForm';
import EntryList from '../components/EntryList';
import SymptomSliders from '../components/SymptomSliders';
import SymptomChart from '../components/SymptomChart';

export default function Dashboard() {
  // Rounded to the hour so the query key doesn't thrash on every render.
  const since = useMemo(() => dayjs().startOf('hour').subtract(7, 'day').toISOString(), []);

  const entriesQuery = useQuery({
    queryKey: ['entries', { since, limit: 20 }],
    queryFn: () => api.get<Entry[]>(`/api/entries?since=${encodeURIComponent(since)}&limit=20`),
  });

  const symptomsQuery = useQuery({
    queryKey: ['symptoms', { since }],
    queryFn: () => api.get<SymptomReading[]>(`/api/symptoms?since=${encodeURIComponent(since)}`),
  });

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>Today</Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={3}>
            <Paper variant="outlined" sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>Quick add</Typography>
              <EntryForm />
            </Paper>
            <SymptomSliders />
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={3}>
            <SymptomChart readings={symptomsQuery.data ?? []} />
            <Box>
              <Typography variant="h6" sx={{ mb: 2 }}>Recent entries</Typography>
              <EntryList entries={entriesQuery.data ?? []} />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
